import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { ACTION, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { FabricChannel } from '@atlaskit/analytics-listeners/types';
import { logException } from '@atlaskit/editor-common/monitoring';
import { PLATFORM } from '../../analytics/events';
import uuid from 'uuid';
export var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary() {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      errorCaptured: false,
      domError: false
    });
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "fireAnalyticsEvent",
    value: function fireAnalyticsEvent(event) {
      var createAnalyticsEvent = this.props.createAnalyticsEvent;
      if (createAnalyticsEvent) {
        var channel = FabricChannel.editor;
        createAnalyticsEvent(event).fire(channel);
      }
    }
  }, {
    key: "hasFallback",
    value: function hasFallback() {
      return typeof this.props.fallbackComponent !== 'undefined';
    }
  }, {
    key: "shouldRecover",
    value: function shouldRecover() {
      return this.hasFallback() && this.state.errorCaptured;
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var _this$props$additiona,
        _this2 = this;
      var additionalInfo = (_this$props$additiona = this.props.additionalInfo) !== null && _this$props$additiona !== void 0 ? _this$props$additiona : '';
      this.fireAnalyticsEvent({
        action: ACTION.CRASHED,
        actionSubject: this.props.component,
        actionSubjectId: this.props.componentId,
        eventType: EVENT_TYPE.OPERATIONAL,
        attributes: {
          platform: PLATFORM.WEB,
          errorMessage: "".concat(additionalInfo).concat(error === null || error === void 0 ? void 0 : error.message),
          componentStack: (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack) || undefined,
          errorRethrown: Boolean(this.props.rethrowError)
        }
      });
      logException(error, {
        location: 'renderer'
      });
      var pattern = /Failed to execute.*on 'Node'.*/;
      var matchesPattern = pattern.test(error.message);
      if (matchesPattern) {
        this.fireAnalyticsEvent({
          action: ACTION.CAUGHT_DOM_ERROR,
          actionSubject: this.props.component,
          actionSubjectId: this.props.componentId,
          eventType: EVENT_TYPE.OPERATIONAL,
          attributes: {
            platform: PLATFORM.WEB,
            errorMessage: "".concat(additionalInfo).concat(error === null || error === void 0 ? void 0 : error.message)
          }
        });
        this.setState(function () {
          return {
            domError: true
          };
        });
      }
      if (this.hasFallback()) {
        this.setState({
          errorCaptured: true
        }, function () {
          if (_this2.props.rethrowError) {
            throw error;
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.domError) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: uuid()
        }, this.props.children);
      }
      if (this.shouldRecover()) {
        return this.props.fallbackComponent;
      }
      return this.props.children;
    }
  }]);
  return ErrorBoundary;
}(React.Component);